import dayjs from "dayjs";

export const scoreFormInputsValidation = (scoreInfoQuestions: any, answers: any, testDate: any) => {
    let hasRequiredFieldsFilled = true;
    if (
        !answers.hasOwnProperty("HasTakenOfficialTest") ||
        answers["HasTakenOfficialTest"] === undefined ||
        answers["HasTakenOfficialTest"] === ""
    ) {
        hasRequiredFieldsFilled = false;
    }
    // ----------------------------
    // Begin Question 1 Yes path
    if (
        answers.hasOwnProperty("HasTakenOfficialTest") &&
        answers["HasTakenOfficialTest"] === true
    ) {
        if (!answers.hasOwnProperty("HasOfficialTestScore") ||
            answers["HasOfficialTestScore"] === undefined ||
            answers["HasOfficialTestScore"] === ""
        ) {
            hasRequiredFieldsFilled = false;
        }
        // -------------------------
        // Begin Question 2 Yes path

        if (answers["HasOfficialTestScore"] === true) {
            if (!answers.hasOwnProperty("OfficialTestScore.ExamDate") ||
                !answers.hasOwnProperty("OfficialTestScore.Components") ||
                !answers.hasOwnProperty("GoalScore.Components") ||
                !answers.hasOwnProperty("OfficialTestFiles") ||
                !answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds")
            ) {
                hasRequiredFieldsFilled = false;
            }
            // Test score validation
            if (scoreInfoQuestions && scoreInfoQuestions[0].SubQuestions[0].SubQuestions[1].Value &&
                answers.hasOwnProperty("OfficialTestScore.Components")) {
                answers["OfficialTestScore.Components"]?.forEach((answer: any) => {
                    scoreInfoQuestions[0].SubQuestions[0].SubQuestions[1].Value?.forEach((data: any) => {
                        if (data.Name === answer.Name &&
                            (parseInt(answer.Value) < data.ScaleMinValue ||
                                parseInt(answer.Value) > data.ScaleMaxValue)) {
                            hasRequiredFieldsFilled = false;
                        }
                    })
                })
            }
            // Goal score validation
            if (scoreInfoQuestions && scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value &&
                answers.hasOwnProperty("GoalScore.Components")) {
                answers["GoalScore.Components"]?.forEach((answer: any) => {
                    scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value?.forEach((data: any) => {
                        if (data.Name === answer.Name &&
                            (parseInt(answer.Value) < data.ScaleMinValue ||
                                parseInt(answer.Value) > data.ScaleMaxValue)) {
                            hasRequiredFieldsFilled = false;
                        }
                    })
                })
            }
            // File upload input validation
            if (answers.hasOwnProperty("OfficialTestFiles") &&
                Array.isArray(answers["OfficialTestFiles"]) &&
                answers["OfficialTestFiles"].length === 0
            ) {
                hasRequiredFieldsFilled = false;
            }
            // Begin Question 3 Yes path
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === true) {
                if (!answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === undefined ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === "") {
                    hasRequiredFieldsFilled = false;
                }
                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate")
                    && dayjs(answers["FutureOfficialTestAfterCourseEndsDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }
            // End Question 3 Yes path 
            // Begin Question 3 No path
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === false) {
                if (!answers.hasOwnProperty("FutureOfficialTestTargetTestDate") ||
                    answers["FutureOfficialTestTargetTestDate"] === undefined ||
                    answers["FutureOfficialTestTargetTestDate"] === "") {
                    hasRequiredFieldsFilled = false;
                }
                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestTargetTestDate")
                    && dayjs(answers["FutureOfficialTestTargetTestDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }
            // End Question 3 No path

            // End Question 2 Yes path
            // -------------------------
        } else {
            // -------------------------
            // Begin Question 2 No path
            if (!answers.hasOwnProperty("GoalScore.Components") ||
                !answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds")) {
                hasRequiredFieldsFilled = false;
            }

            if (answers.hasOwnProperty("GoalScore.Components") &&
                answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds")) {
                // Goal score validation
                if (scoreInfoQuestions && scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value
                    && answers.hasOwnProperty("GoalScore.Components")) {
                    answers["GoalScore.Components"]?.forEach((answer: any) => {
                        scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value?.forEach((data: any) => {
                            if (data.Name === answer.Name
                                && (parseInt(answer.Value) < data.ScaleMinValue ||
                                    parseInt(answer.Value) > data.ScaleMaxValue)) {
                                hasRequiredFieldsFilled = false;
                            }
                        })
                    })
                }

                // Begin Question 3 Yes path
                if (answers["HasFutureOfficialTestAfterCourseEnds"] === true) {
                    if (!answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") ||
                        answers["FutureOfficialTestAfterCourseEndsDate"] === undefined ||
                        answers["FutureOfficialTestAfterCourseEndsDate"] === "") {
                        hasRequiredFieldsFilled = false;
                    }
                    // acknowledge
                    if (answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") &&
                        dayjs(answers["FutureOfficialTestAfterCourseEndsDate"]).isAfter(testDate)) {
                        if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                            answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                            hasRequiredFieldsFilled = false;
                        }
                    }
                }
                // End Question 3 Yes path
                // Begin Question 3 No path
                if (answers["HasFutureOfficialTestAfterCourseEnds"] === false) {
                    if (!answers.hasOwnProperty("FutureOfficialTestTargetTestDate") ||
                        answers["FutureOfficialTestTargetTestDate"] === undefined ||
                        answers["FutureOfficialTestTargetTestDate"] === "") {
                        hasRequiredFieldsFilled = false;
                    }
                    // acknowledge
                    if (answers.hasOwnProperty("FutureOfficialTestTargetTestDate") &&
                        dayjs(answers["FutureOfficialTestTargetTestDate"]).isAfter(testDate)) {
                        if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                            answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                            hasRequiredFieldsFilled = false;
                        }
                    }
                }
                // End Question 3 No path
            }
            // -------------------------
            // End Question 2 No path
        }
    }
    // ----------------------------
    // End Question 1 Yes path

    // ----------------------------
    // Begin Question 1 No path
    if (
        answers.hasOwnProperty("HasTakenOfficialTest") &&
        answers["HasTakenOfficialTest"] === false
    ) {
        if (!answers.hasOwnProperty("GoalScore.Components") ||
            !answers.hasOwnProperty("HasFutureOfficialTestBeforeCourseEnds")) {
            hasRequiredFieldsFilled = false;
        }

        // Goal score validation
        if (scoreInfoQuestions && scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value
            && answers.hasOwnProperty("GoalScore.Components")) {
            answers["GoalScore.Components"]?.forEach((answer: any) => {
                scoreInfoQuestions[0].SubQuestions[0].SubQuestions[2].Value?.forEach((data: any) => {
                    if (data.Name === answer.Name
                        && (parseInt(answer.Value) < data.ScaleMinValue ||
                            parseInt(answer.Value) > data.ScaleMaxValue)) {
                        hasRequiredFieldsFilled = false;
                    }
                })
            })
        }

        // Begin Question 3 Yes path
        if (answers["HasFutureOfficialTestBeforeCourseEnds"] === true) {
            // Question 3a
            if (!answers.hasOwnProperty("FutureOfficialTestBeforeCourseEndsDate") ||
                answers["FutureOfficialTestBeforeCourseEndsDate"] === undefined ||
                answers["FutureOfficialTestBeforeCourseEndsDate"] === "") {
                hasRequiredFieldsFilled = false;
            }

            // Question 4
            if (!answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") ||
                answers["HasFutureOfficialTestAfterCourseEnds"] === undefined ||
                answers["HasFutureOfficialTestAfterCourseEnds"] === "") {
                hasRequiredFieldsFilled = false;
            }

            // Question 4 Yes path
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === true) {

                // Question 4a
                if (!answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === undefined ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === "") {
                    hasRequiredFieldsFilled = false;
                }
                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") &&
                    dayjs(answers["FutureOfficialTestAfterCourseEndsDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }

            // Question 4 No path
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === false) {

                // Question 5
                if (!answers.hasOwnProperty("FutureOfficialTestTargetTestDate") ||
                    answers["FutureOfficialTestTargetTestDate"] === undefined ||
                    answers["FutureOfficialTestTargetTestDate"] === "") {
                    hasRequiredFieldsFilled = false;
                }

                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestTargetTestDate") &&
                    dayjs(answers["FutureOfficialTestTargetTestDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }
        }
        // End Question 3 Yes path

        // Begin Question 3 No path
        if (answers["HasFutureOfficialTestBeforeCourseEnds"] === false) {
            // Question 4
            if (!answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") ||
                answers["HasFutureOfficialTestAfterCourseEnds"] === undefined ||
                answers["HasFutureOfficialTestAfterCourseEnds"] === "") {
                hasRequiredFieldsFilled = false;
            }

            // Question 4 No
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === false) {

                // Question 5
                if (!answers["FutureOfficialTestTargetTestDate"] ||
                    answers["FutureOfficialTestTargetTestDate"] === undefined ||
                    answers["FutureOfficialTestTargetTestDate"] === ""
                ) {
                    hasRequiredFieldsFilled = false;
                }

                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestTargetTestDate") &&
                    dayjs(answers["FutureOfficialTestTargetTestDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }

            // Question 4 Yes
            if (answers.hasOwnProperty("HasFutureOfficialTestAfterCourseEnds") &&
                answers["HasFutureOfficialTestAfterCourseEnds"] === true) {

                // Question 4a
                if (!answers["FutureOfficialTestAfterCourseEndsDate"] ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === undefined ||
                    answers["FutureOfficialTestAfterCourseEndsDate"] === ""
                ) {
                    hasRequiredFieldsFilled = false;
                }

                // acknowledge
                if (answers.hasOwnProperty("FutureOfficialTestAfterCourseEndsDate") &&
                    dayjs(answers["FutureOfficialTestAfterCourseEndsDate"]).isAfter(testDate)) {
                    if (!answers.hasOwnProperty("InvalidOfficialTestTargetTestDateAcknowledgement") ||
                        answers["InvalidOfficialTestTargetTestDateAcknowledgement"] === false) {
                        hasRequiredFieldsFilled = false;
                    }
                }
            }
        }
        // End Question 3 No path
    }
    // ----------------------------
    // End Question 1 No path

    return hasRequiredFieldsFilled;
};